export enum InputParameterHierarchyType {
  AI_FEATURE_PRESET = 'ai-feature-presets',
  MEETING_SUMMARY_TEMPLATE = 'meeting-summary-template',
  MEETING_PREPARATION_TEMPLATE = 'meeting-preparation-template',
  MEETING_PREPARATION_EMAIL_TEMPLATE = 'meeting-preparation-email-template',
  MEETING_AGENDA_CONFIG = 'meeting-agenda-config',
  EMAIL_RESPONSE_TEMPLATE = 'email-response-template',
  NEW_EMAIL_TEMPLATE = 'new-email-template',
  DOCUMENT_SUMMARY_TEMPLATE = 'document-summary-template',
}

export const InputParameterHierarchyTypeDisplayName: Record<InputParameterHierarchyType, string> = {
  [InputParameterHierarchyType.AI_FEATURE_PRESET]: 'AI Feature Presets',
  [InputParameterHierarchyType.MEETING_SUMMARY_TEMPLATE]: 'Meeting Summary',
  [InputParameterHierarchyType.MEETING_PREPARATION_TEMPLATE]: 'Meeting Prep',
  [InputParameterHierarchyType.MEETING_PREPARATION_EMAIL_TEMPLATE]: 'Meeting Prep Email',
  [InputParameterHierarchyType.MEETING_AGENDA_CONFIG]: 'Meeting Agenda Config',
  [InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE]: 'Reply Email',
  [InputParameterHierarchyType.NEW_EMAIL_TEMPLATE]: 'New Email',
  [InputParameterHierarchyType.DOCUMENT_SUMMARY_TEMPLATE]: 'Document Summary',
}

interface InputParametersHierarchyConfigComponentProps {
  type: InputParameterHierarchyType
  typeId: string
  inputParametersSchema: { [key: string]: any } | undefined
  defaultInputParameters: { [key: string]: any } | null
  onHide: () => void
  showCustomizationSetting: boolean
  ipHierarchyEnabled: boolean
}

export interface MeetingTemplateInputParametersHierarchyConfigComponentProps extends InputParametersHierarchyConfigComponentProps {
  meetingTemplateId?: string
}

export interface EmailTypeInputParametersHierarchyConfigComponentProps extends InputParametersHierarchyConfigComponentProps {
  emailTypeId?: string
}

export interface DocumentTypeInputParametersHierarchyConfigComponentProps extends InputParametersHierarchyConfigComponentProps {
  documentTypeId?: string
}
export interface MeetingAgendaInputParameters {
  fixed: string[]
  smartSuggestions?: string[]
  customInstructions: string
}

export const isMeetingAgendaInputParameters = (inputParameters: unknown): inputParameters is MeetingAgendaInputParameters => {
  return (
    typeof inputParameters === 'object' &&
    inputParameters !== null &&
    inputParameters !== undefined &&
    'fixed' in inputParameters &&
    'customInstructions' in inputParameters &&
    Array.isArray(inputParameters.fixed) &&
    inputParameters.fixed.every((item) => typeof item === 'string') &&
    typeof inputParameters.customInstructions === 'string' &&
    (!('smartSuggestions' in inputParameters) ||
      (Array.isArray(inputParameters.smartSuggestions) && inputParameters.smartSuggestions.every((item) => typeof item === 'string')))
  )
}
